import { useEffect, type ReactNode } from 'react'
import { useLangue, useLangueVitrine } from '../lib/langue'
import { useTheatre } from '../lib/theatre'
import { ContexteLangueInterface, useLangueInterface } from '../lib/langue-interface'
function LangueDuDocumentHtml() {
  const langue = useLangueInterface()
  useEffect(() => {
    document.documentElement.lang = langue
  }, [langue])
  return null
}
export function LanguePublique({ children }: { readonly children: ReactNode }) {
  const langue = useLangue()
  return (
    <ContexteLangueInterface value={langue}>
      <LangueDuDocumentHtml />
      {children}
    </ContexteLangueInterface>
  )
}
export function LangueMaison({ children }: { readonly children: ReactNode }) {
  const { langue } = useTheatre()
  return (
    <ContexteLangueInterface value={langue ?? 'fr'}>
      <LangueDuDocumentHtml />
      {children}
    </ContexteLangueInterface>
  )
}
export function LangueVitrine({ children }: { readonly children: ReactNode }) {
  const langue = useLangueVitrine()
  return (
    <ContexteLangueInterface value={langue}>
      <LangueDuDocumentHtml />
      {children}
    </ContexteLangueInterface>
  )
}
